module.exports = __webpack_public_path__ + "img/mainhomephn2.c174d729.png";